import { render } from "./TeamTeaser.vue?vue&type=template&id=23adff6e"
import script from "./TeamTeaser.vue?vue&type=script&lang=js"
export * from "./TeamTeaser.vue?vue&type=script&lang=js"

import "./TeamTeaser.vue?vue&type=style&index=0&id=23adff6e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__